// Vendor imports
const { connect } = require('react-redux')
// Container imports
const AppFooter = require('./component-dumb')

function mapStateToProps(state) {
  return {
    hidden: state.env.nativeEmbedded,
    loggedIn: state.user.loggedIn
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onContactClick: function (event) {
      dispatch(function (dispatch, getState) {
        const { user } = getState()
        if (user.loggedIn && window.Intercom) {
          window.Intercom('show')
          event.preventDefault()
        }
      })
    }
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AppFooter
)

module.exports = SmartComponent
